import { render, staticRenderFns } from "./SearchByFilter.vue?vue&type=template&id=70cb6d4f&scoped=true&"
import script from "./SearchByFilter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchByFilter.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb6d4f",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QInput});
